import { BaseSectionCreator } from './baseSectionCreator';
import { IItemSection } from '../itemSection';
import { Product } from '@/store/modules/product';

export class NullSectionCreator extends BaseSectionCreator {

    protected sections: IItemSection[] = [];

    constructor(
        scenePreview: any,
    ) {
        super(scenePreview);
    }

    public create(product: Product): IItemSection[] {
        return this.sections;
    }

    protected applyLanguage(): void {
        //
    }

}
